import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { PersonClausesDialog } from "./PersonClausesDialog";
import HandshakeIcon from '@mui/icons-material/Handshake';

export const PersonClausesDialogButton = (props) => {

    const { personId, customerId, personName, readOnly, customerhasApprovedClause} = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const getButtonColor = () => {
        if (customerhasApprovedClause == undefined) {
            return "primary"
        }

        if (customerhasApprovedClause == true) {
            return "success"
        }

        return "error"
    }

    const handleOpenDialog = () => {
        openDialog({
            Component: PersonClausesDialog,
            componentProps: {
                readOnly:readOnly,
                personId: personId,
                customerId: customerId,
                personName: personName
            },
        });
    };

    return (
        <Button
            variant="outlined"
            startIcon={<HandshakeIcon />}
            fullWidth
            onClick={handleOpenDialog}
            color={getButtonColor()}
        >
            {t("clients.PersonClausesDialog.buttonLabel")}
        </Button>
    );
};